import { Quota } from '../models/survey-quota.model';
import { QUOTA_CATEGORY } from '../constants/survey-quotas.constants';
import { SurveyQuotaCriterion } from './survey-quota-criterion';

export class SurveyQuotaKind {
  public static isLayered(quota: Quota): boolean {
    if (quota.quotaCategory) {
      return quota.quotaCategory === QUOTA_CATEGORY.LAYERED;
    }

    return (
      this._hasSingleCriterion(quota) && this._hasSingleCriteriaCondition(quota)
    );
  }

  public static layered(quotas: readonly Quota[]): Quota[] {
    return quotas.filter((quota) => SurveyQuotaKind.isLayered(quota));
  }

  public static isNested(quota: Quota): boolean {
    if (quota.quotaCategory) {
      return quota.quotaCategory === QUOTA_CATEGORY.NESTED;
    }

    return quota.criteria.length > 1;
  }

  public static nested(quotas: readonly Quota[]): Quota[] {
    return quotas.filter((quota) => SurveyQuotaKind.isNested(quota));
  }

  public static isGrouped(quota: Quota): boolean {
    if (quota.quotaCategory === QUOTA_CATEGORY.GROUPED) {
      return true;
    }

    return (
      this._hasSingleCriterion(quota) &&
      !this._hasSingleCriteriaCondition(quota)
    );
  }

  public static grouped(quotas: readonly Quota[]): Quota[] {
    return quotas.filter((quota) => SurveyQuotaKind.isGrouped(quota));
  }

  private static _hasSingleCriterion(quota: Quota): boolean {
    return quota.criteria.length === 1;
  }

  private static _hasSingleCriteriaCondition(quota: Quota): boolean {
    return new SurveyQuotaCriterion(quota.criteria[0]).values().length === 1;
  }
}
